import styled from 'styled-components'

import { H2 } from './H2'

const H3 = styled(H2).attrs({ as: 'h3' }) `
  font-size: 26px;
  font-weight: 300;
  color: #A1A1A1;
`

export { H3 }
